module.exports = __webpack_public_path__ + "img/1121817891.55759553.png";